import React, { useEffect, useState } from "react";

const PlayIcon = () => (
  <div className="absolute inset-0 flex items-center justify-center z-20">
    <div className="flex h-[88px] w-[88px] items-center justify-center rounded-full bg-white/18 backdrop-blur-[3px]">
      <div className="ml-1 h-0 w-0 border-y-[16px] border-y-transparent border-l-[24px] border-l-white/90" />
    </div>
  </div>
);

const CloseIcon = () => (
  <svg
    className="h-7 w-7"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const MediaCarousel = ({ items = [] }) => {
  const duplicated = [...items, ...items];
  const [selectedItem, setSelectedItem] = useState(null);

  const openModal = (item) => {
    setSelectedItem(item);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedItem(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") closeModal();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <>
      <div className="w-full overflow-hidden">
        <div className="flex w-max gap-6 animate-marquee">
          {duplicated.map((item, index) => (
            <article
              key={`${item.id || index}-${index}`}
              onClick={() => openModal(item)}
              className="relative h-[300px] w-[300px] shrink-0 overflow-hidden rounded-[22px] border-2 border-white/80 bg-[#d9d9d9] cursor-pointer"
            >
              {item.type === "video" ? (
                <>
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    width={320}
                    height={320}
                    className="h-full w-full object-cover"
                  />
                  <PlayIcon />
                </>
              ) : (
                <img
                  src={item.src}
                  alt={item.title}
                  width={320}
                  height={320}
                  className="h-full w-full object-cover"
                />
              )}

              <div className="absolute inset-0 bg-white/28 z-10" />
              <div className="absolute inset-0 z-10 bg-gradient-to-t from-white/55 via-white/28 to-white/5" />
              <div className="absolute inset-x-0 bottom-0 h-[115px] bg-white/52 backdrop-blur-[2px] z-10" />

              <div className="absolute bottom-7 left-8 right-8 z-20 text-black">
                <h3 className="font-montserrat text-[16px] font-medium leading-none">
                  {item.title}
                </h3>

                <div className="mt-1 flex items-center gap-3 font-montserrat text-[13px] leading-none text-black/85">
                  <span>{item.date}</span>
                  <span>•</span>
                  <span>{item.info}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      {selectedItem && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 px-3 py-4 sm:px-4 sm:py-6"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-[92vw] sm:max-w-[90vw] md:max-w-[820px] lg:max-w-[1000px]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative overflow-hidden rounded-[6px] border-[3px] border-white/80 bg-black/80 shadow-2xl px-4 py-4 sm:px-6 sm:py-5 md:px-10 md:py-6 lg:px-[80px] lg:py-[40px]">
              <button
                onClick={closeModal}
                className="absolute top-3 right-3 sm:top-4 sm:right-4 z-30 flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center rounded-full bg-black/25 text-white backdrop-blur-md transition hover:bg-black/40"
                aria-label="Fechar modal"
              >
                <CloseIcon />
              </button>

              <div className="relative">
                {selectedItem.type === "video" ? (
                  <video
                    src={selectedItem.videoSrc}
                    controls
                    autoPlay
                    className="max-h-[50vh] sm:max-h-[55vh] md:max-h-[60vh] w-full object-contain bg-black"
                  />
                ) : (
                  <img
                    src={selectedItem.src}
                    alt={selectedItem.title}
                    className="max-h-[50vh] sm:max-h-[55vh] md:max-h-[60vh] w-full object-contain bg-black"
                  />
                )}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="pointer-events-none absolute bottom-4 left-4 right-4 sm:bottom-5 sm:left-5 sm:right-5 md:bottom-6 md:left-6 md:right-6 lg:bottom-[20px] lg:left-[60px] lg:right-[60px] z-20 text-white">
                  <h3 className="font-montserrat text-[12px] sm:text-[13px] md:text-[14px] font-semibold drop-shadow-md">
                    {selectedItem.title}
                  </h3>
                  <div className="mt-1 flex items-center gap-2 sm:gap-3 font-montserrat text-[10px] sm:text-[11px] md:text-[12px] text-white/85 drop-shadow-md">
                    <span>{selectedItem.date}</span>
                    <span>•</span>
                    <span>{selectedItem.info}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MediaCarousel;